import React from "react";
import { Link } from "react-router-dom";

/**
 * Mapas de componentes para <Trans components={...} /> cuando la traducción usa <lnk>...</lnk>.
 * Siempre usar con Trans, nunca con t().
 */
export const transLnkComponents = {
	login: { lnk: <Link to="/login" /> },
	rememberPassword: { lnk: <Link to="/remember-password" /> },
	groups: { lnk: <Link className="alink" to="/groups" /> },
};
